export const d1 =
`
Like I said earlier, the computer needs to keep track of which operations are taking place 
in order to be able to retrace its steps, and properly compute derivatives. This info is stored in the 
form of a graph. The graph contains variables as nodes, and operations as its edges. This graph is 
what we call the 
**Directed Acyclic Graph**, of the computation, which is just a really fancy way of saying that:
1. The graph is specific about direction; if z = sin(x) then it doesn't mean x = sin(z),
2. Acyclic meaning there are no loops in the graph; you cannot define variables circularly x = y, y = x!
`.trim();

// diagram of computation graph

export const d2 =
`
Once we have a technique to store this DAG, the rest of the implementation becomes super simple. Now, 
if you are using a language that supports classes or user defined types, with operator overloading, this 
is most likely what you would be using for this.

The acyclic nature of the graph lends itself nicely to be 
modelled via operator overloading. This is the technique I used in [picograd](https://github.com/StealthyPanda/picograd), and might be possible in whatever 
language you are using too.
`.trim();